module.exports = __webpack_public_path__ + "static/media/hide_seek.1796405d.png";